<!--
 * @创建文件时间: 2019-12-29 19:32:42
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-19 03:13:16
 * @联系Qq:1638245306
 * @文件介绍: 
 -->
<!-- 标题分割组件 -->
<template>
 <div>
      <fieldset v-if="title" class="basicInformation">
        <legend class="basicInformation-border">{{title}}</legend>
    </fieldset>
     <fieldset v-else class="basicInformation">
    </fieldset>
 </div>
</template>
<script>
export default {
name:'divider',
props:{
    title:{
        type:String,
        default:'基本信息'
    }
  }
}
</script>
<style lang='scss' scoped>
.basicInformation .basicInformation-border {
    line-height: 24px !important;
}
/*导航标识样式*/
 .imgVideo_class .basicInformation{
    border-width: 0px 0 0;
}
 .imgVideo_class .basicInformation .basicInformation-border{
    background-color: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
}

.basicInformation {
    border-width: 1px 0 0;
    border-style: solid;
    border-color: #409EFF;
    width: 98.5%;
    margin-top: 20px;
    padding-bottom: 0px;
    height: 35px;
}

.basicInformation>legend {
    background-color: #409EFF;
    border-radius: 4px;
    border: none;
    color: #fff;
    font-size: 14px;
    padding: 8px 14px;
    margin-left: 20px;
}
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/divider.vue"
}
</vue-filename-injector>
